window.observerCount = 0;
window.mutationObservers = {};
window.registerMutationObserver = function(selectors, callback, runBeforehand = false, useWhenConsented = true, debounceTimeout = null) {
	selectors.forEach(selector => {
		if (Object.keys(window.mutationObservers).indexOf(selector.observeSelector) === -1) {
			window.mutationObservers[selector.observeSelector] = [];
		}

		window.mutationObservers[selector.observeSelector].push({
			callbackSelectors: selector.callbackSelectors,
			callback,
			runBeforehand,
			useWhenConsented,
			debounceTimeout
		});
	});
};